import axios from "axios";
import React, { useEffect, useState } from "react";
import "../../../style/css/admin/User.css";
import { Navbar } from "../../../commn/Navbar.js";
import { Link, useNavigate } from "react-router-dom";

export const EntrepreneurshipemailDisplay = () => {
  const [data, setData] = useState([]);
  const navi = useNavigate();

  useEffect(() => {
    // Fetch data on component mount
    axios
      .get("/api/entrepreneurshipadmin/get", {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("user")).token,
        },
      })
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => console.log("Error fetching data:", err));
  }, []); // Empty dependency array ensures it runs only once

  const Deleteadmin = (id) => {
    axios
      .delete(`/api/entrepreneurshipadmin/delete/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("user")).token,
        },
      })
      .then(() => {
        alert("Successfully Deleted");
        navi("/Aentraemail");
      })
      .catch((err) => console.log("Error deleting data:", err));
  };

  return (
    <div>
      <Navbar />
      <div className="mt-5" style={{ textAlign: "center" }}>
        <div className="dbtn">
          <Link to="/Aentraadd">
            <button className="btn btn-primary mt-5">
              Add Entrepreneurship Emails
            </button>
          </Link>
          <Link to="/Aentra">
            <button className="btn btn-primary mt-5 ml-2">
              Entrepreneurship
            </button>
          </Link>
        </div>
        <div className="td">
          <h3>Entrepreneurship Email</h3>
          <table
            className="table shadow"
            style={{ width: "70%", marginLeft: "15%", marginRight: "15%" }}
          >
            <thead>
              <tr>
                <th scope="col">User Name</th>
                <th scope="col">Email</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {data.map((AEemail) => (
                <tr key={AEemail._id}>
                  {" "}
                  {/* Added key prop */}
                  <td>{AEemail.name}</td>
                  <td>{AEemail.email}</td>
                  <td>
                    <Link to={`/Aentraemailupdate/${AEemail._id}`}>
                      <button className="btn">Update</button>
                    </Link>
                    <button
                      className="btn"
                      onClick={() => Deleteadmin(AEemail._id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
